export const emailValidationRegex: RegExp = /\S+@\S+\.\S+/

export const phoneValidationRegex: RegExp = /\(?\d{3}\)?-? *\d{3}-? *-?\d{4}/
